import { render, staticRenderFns } from "./QuizElement.vue?vue&type=template&id=5e9b3b24&"
import script from "./QuizElement.vue?vue&type=script&lang=js&"
export * from "./QuizElement.vue?vue&type=script&lang=js&"
import style0 from "./QuizElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports